import { render, staticRenderFns } from "./Artistas.vue?vue&type=template&id=396b0ac6&"
import script from "./Artistas.vue?vue&type=script&lang=js&"
export * from "./Artistas.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports